module.exports = __webpack_public_path__ + "img/141.8.188421c2.png";